<template>
	<div v-if="data?.logo?.filename">
		<component
			:is="data.link?.linktype === 'story' ? AbsoluteInternalLink : NuxtLink"
			v-if="data.link?.cached_url"
			:to="data.link?.cached_url"
			tabindex="-1"
			:target="data.link?.target"
			@click="trackHeaderEvent('custom_logo')"
		>
			<NuxtImg
				provider="storyblok"
				height="55"
				:src="data.logo.filename"
				:alt="data.logo.alt || ''"
				loading="lazy"
				class="!w-auto max-lg:h-[2rem] lg:h-[3.4375rem] transition-all duration-100"
				:class="{'!h-[2rem]': isSticky}"
			/>
		</component>
		<NuxtImg
			v-else
			provider="storyblok"
			height="55"
			:src="data.logo.filename"
			:alt="data.logo.alt || ''"
			loading="lazy"
			class="!w-auto max-lg:h-[2rem] lg:h-[3.4375rem] transition-all duration-100"
			:class="{'!h-[2rem]': isSticky}"
		/>
	</div>
</template>

<script setup lang="ts">
	import type {CampaignLogoStoryblok} from '~/storyblok/types';

	type Props = {
		isSticky?: boolean;
	};

	defineProps<Props>();

	const NuxtLink = resolveComponent('NuxtLink');
	const AbsoluteInternalLink = resolveComponent('AbsoluteInternalLink');
	const {data} = await useSingleStoryFetch<CampaignLogoStoryblok, CampaignLogoStoryblok | null>(
		'CampaignLogo',
		{
			starts_with: '_globus-cz/komponenty/',
			content_type: 'CampaignLogo',
		},
		{
			immediate: true,
			transform: (data) => data?.[0]?.content || null,
		},
	);
</script>
